import { Navigate } from 'react-router-dom';

import { useAuthContext } from '../context/auth-context';
import Auth from '../components/Auth/Auth';

const AuthPage: React.FC = () => {
  const { isAuth} = useAuthContext();
  
  
  if (isAuth) {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('continue');
    return <Navigate to={redirect ? redirect : '/'} replace />;
  }

  return (
    <Auth/>
  );
};

export default AuthPage;
